<template>
    <div @click="emitIt" class="learnworlds-screen-caption bottom lw-brand-bg-fadeout60 js-lw-flexible-wrapper js-screen-caption">
        <slot name="caption"></slot>
    </div>

</template>

<script>

    export default {
        data () {
            return {}
        },
        methods : {
            emitIt () {
                this.$emit("captionClicked")
            }
        }
    }
</script>
